/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import _ImageEditorBalloon from './ImageEditorBalloon.svg';
import _ImageEditorBalloonActive from './ImageEditorBalloonActive.svg';
import _ImageEditorBalloonWide from './ImageEditorBalloonWide.svg';
import _ImageEditorBalloonWideActive from './ImageEditorBalloonWideActive.svg';
import _ImageEditorClassic from './ImageEditorClassic.svg';
import _ImageEditorClassicActive from './ImageEditorClassicActive.svg';
import _ImageEditorClassicWide from './ImageEditorClassicWide.svg';
import _ImageEditorClassicWideActive from './ImageEditorClassicWideActive.svg';
import _ImageEditorDecoupled from './ImageEditorDecoupled.svg';
import _ImageEditorDecoupledActive from './ImageEditorDecoupledActive.svg';
import _ImageEditorDecoupledWide from './ImageEditorDecoupledWide.svg';
import _ImageEditorDecoupledWideActive from './ImageEditorDecoupledWideActive.svg';
import _ImageEditorInline from './ImageEditorInline.svg';
import _ImageEditorInlineActive from './ImageEditorInlineActive.svg';
import _ImageEditorInlineWide from './ImageEditorInlineWide.svg';
import _ImageEditorInlineWideActive from './ImageEditorInlineWideActive.svg';

import _ImageInstallationEditorBalloon from './ImageInstallationEditorBalloon.svg';
import _ImageInstallationEditorBalloonStarter from './ImageInstallationEditorBalloonStarter.svg';
import _ImageInstallationEditorClassic from './ImageInstallationEditorClassic.svg';
import _ImageInstallationEditorClassicStarter from './ImageInstallationEditorClassicStarter.svg';
import _ImageInstallationEditorDecoupled from './ImageInstallationEditorDecoupled.svg';
import _ImageInstallationEditorDocumentStarter from './ImageInstallationEditorDocumentStarter.svg';
import _ImageInstallationEditorInline from './ImageInstallationEditorInline.svg';
import _ImageInstallationEditorInlineStarter from './ImageInstallationEditorInlineStarter.svg';
import _ImageInstallationPresetFeatureRich from './ImageInstallationPresetFeatureRich.svg';
import _ImageInstallationPresetArticle from './ImageInstallationPresetArticle.svg';
import _ImageInstallationPresetDocument from './ImageInstallationPresetDocument.svg';
import _ImageInstallationPresetHtml from './ImageInstallationPresetHtml.svg';
import _ImageInstallationPresetMicro from './ImageInstallationPresetMicro.svg';
import _ImageInstallationPresetNotion from './ImageInstallationPresetNotion.svg';

import _ImagePresetArticle from './ImagePresetArticle.svg';
import _ImagePresetArticleActive from './ImagePresetArticleActive.svg';
import _ImagePresetArticleWide from './ImagePresetArticleWide.svg';
import _ImagePresetArticleWideActive from './ImagePresetArticleWideActive.svg';
import _ImagePresetDocument from './ImagePresetDocument.svg';
import _ImagePresetDocumentActive from './ImagePresetDocumentActive.svg';
import _ImagePresetDocumentWide from './ImagePresetDocumentWide.svg';
import _ImagePresetDocumentWideActive from './ImagePresetDocumentWideActive.svg';
import _ImagePresetEmail from './ImagePresetEmail.svg';
import _ImagePresetEmailActive from './ImagePresetEmailActive.svg';
import _ImagePresetEmailWide from './ImagePresetEmailWide.svg';
import _ImagePresetEmailWideActive from './ImagePresetEmailWideActive.svg';
import _ImagePresetHtml from './ImagePresetHtml.svg';
import _ImagePresetHtmlActive from './ImagePresetHtmlActive.svg';
import _ImagePresetHtmlWide from './ImagePresetHtmlWide.svg';
import _ImagePresetHtmlWideActive from './ImagePresetHtmlWideActive.svg';
import _ImagePresetMicro from './ImagePresetMicro.svg';
import _ImagePresetMicroActive from './ImagePresetMicroActive.svg';
import _ImagePresetMicroWide from './ImagePresetMicroWide.svg';
import _ImagePresetMicroWideActive from './ImagePresetMicroWideActive.svg';
import _ImagePresetNotion from './ImagePresetNotion.svg';
import _ImagePresetNotionActive from './ImagePresetNotionActive.svg';
import _ImagePresetNotionWide from './ImagePresetNotionWide.svg';
import _ImagePresetNotionWideActive from './ImagePresetNotionWideActive.svg';

import _ImageToolbarEditorBalloon from './ImageToolbarEditorBalloon.svg';
import _ImageToolbarEditorBalloonActive from './ImageToolbarEditorBalloonActive.svg';
import _ImageToolbarEditorBlock from './ImageToolbarEditorBlock.svg';
import _ImageToolbarEditorBlockActive from './ImageToolbarEditorBlockActive.svg';
import _ImageToolbarEditorClassic from './ImageToolbarEditorClassic.svg';
import _ImageToolbarEditorClassicActive from './ImageToolbarEditorClassicActive.svg';

import _IconArrowUp from './IconArrowUp.svg';
import _IconArrowDown from './IconArrowDown.svg';
import _IconCustomerPortal from './IconCustomerPortal.svg';
import _IconClose from './IconClose.svg';
import _IconCloseBuilder from './IconCloseBuilder.svg';
import _IconDocumentation from './IconDocumentation.svg';
import _IconSignOut from './IconSignOut.svg';
import _IconShowMore from './IconShowMore.svg';
import _LogoCKEditor5 from './LogoCKEditor5.svg';
import _LogoLock from './LogoLock.svg';
import _LogoDownload from './LogoDownload.svg';

import _ArticleImageRightIcon from './ckeditor5/ArticleImageRightIcon.svg?raw';

export const ImageEditorBalloon: string = _ImageEditorBalloon;
export const ImageEditorBalloonActive: string = _ImageEditorBalloonActive;
export const ImageEditorBalloonWide: string = _ImageEditorBalloonWide;
export const ImageEditorBalloonWideActive: string = _ImageEditorBalloonWideActive;
export const ImageEditorClassic: string = _ImageEditorClassic;
export const ImageEditorClassicActive: string = _ImageEditorClassicActive;
export const ImageEditorClassicWide: string = _ImageEditorClassicWide;
export const ImageEditorClassicWideActive: string = _ImageEditorClassicWideActive;
export const ImageEditorDecoupled: string = _ImageEditorDecoupled;
export const ImageEditorDecoupledActive: string = _ImageEditorDecoupledActive;
export const ImageEditorDecoupledWide: string = _ImageEditorDecoupledWide;
export const ImageEditorDecoupledWideActive: string = _ImageEditorDecoupledWideActive;
export const ImageEditorInline: string = _ImageEditorInline;
export const ImageEditorInlineActive: string = _ImageEditorInlineActive;
export const ImageEditorInlineWide: string = _ImageEditorInlineWide;
export const ImageEditorInlineWideActive: string = _ImageEditorInlineWideActive;

export const ImageInstallationEditorBalloon: string = _ImageInstallationEditorBalloon;
export const ImageInstallationEditorBalloonStarter: string = _ImageInstallationEditorBalloonStarter;
export const ImageInstallationEditorClassic: string = _ImageInstallationEditorClassic;
export const ImageInstallationEditorClassicStarter: string = _ImageInstallationEditorClassicStarter;
export const ImageInstallationEditorDecoupled: string = _ImageInstallationEditorDecoupled;
export const ImageInstallationEditorDocumentStarter: string = _ImageInstallationEditorDocumentStarter;
export const ImageInstallationEditorInline: string = _ImageInstallationEditorInline;
export const ImageInstallationEditorInlineStarter: string = _ImageInstallationEditorInlineStarter;
export const ImageInstallationPresetFeatureRich: string = _ImageInstallationPresetFeatureRich;
export const ImageInstallationPresetArticle: string = _ImageInstallationPresetArticle;
export const ImageInstallationPresetDocument: string = _ImageInstallationPresetDocument;
export const ImageInstallationPresetHtml: string = _ImageInstallationPresetHtml;
export const ImageInstallationPresetMicro: string = _ImageInstallationPresetMicro;
export const ImageInstallationPresetNotion: string = _ImageInstallationPresetNotion;

export const ImagePresetArticle: string = _ImagePresetArticle;
export const ImagePresetArticleActive: string = _ImagePresetArticleActive;
export const ImagePresetArticleWide: string = _ImagePresetArticleWide;
export const ImagePresetArticleWideActive: string = _ImagePresetArticleWideActive;
export const ImagePresetDocument: string = _ImagePresetDocument;
export const ImagePresetDocumentActive: string = _ImagePresetDocumentActive;
export const ImagePresetDocumentWide: string = _ImagePresetDocumentWide;
export const ImagePresetDocumentWideActive: string = _ImagePresetDocumentWideActive;
export const ImagePresetEmail: string = _ImagePresetEmail;
export const ImagePresetEmailActive: string = _ImagePresetEmailActive;
export const ImagePresetEmailWide: string = _ImagePresetEmailWide;
export const ImagePresetEmailWideActive: string = _ImagePresetEmailWideActive;
export const ImagePresetHtml: string = _ImagePresetHtml;
export const ImagePresetHtmlActive: string = _ImagePresetHtmlActive;
export const ImagePresetHtmlWide: string = _ImagePresetHtmlWide;
export const ImagePresetHtmlWideActive: string = _ImagePresetHtmlWideActive;
export const ImagePresetMicro: string = _ImagePresetMicro;
export const ImagePresetMicroActive: string = _ImagePresetMicroActive;
export const ImagePresetMicroWide: string = _ImagePresetMicroWide;
export const ImagePresetMicroWideActive: string = _ImagePresetMicroWideActive;
export const ImagePresetNotion: string = _ImagePresetNotion;
export const ImagePresetNotionActive: string = _ImagePresetNotionActive;
export const ImagePresetNotionWide: string = _ImagePresetNotionWide;
export const ImagePresetNotionWideActive: string = _ImagePresetNotionWideActive;

export const ImageToolbarEditorClassic: string = _ImageToolbarEditorClassic;
export const ImageToolbarEditorClassicActive: string = _ImageToolbarEditorClassicActive;
export const ImageToolbarEditorBalloon: string = _ImageToolbarEditorBalloon;
export const ImageToolbarEditorBalloonActive: string = _ImageToolbarEditorBalloonActive;
export const ImageToolbarEditorBlock: string = _ImageToolbarEditorBlock;
export const ImageToolbarEditorBlockActive: string = _ImageToolbarEditorBlockActive;

export const LogoCKEditor5: string = _LogoCKEditor5;
export const IconArrowUp: string = _IconArrowUp;
export const IconArrowDown: string = _IconArrowDown;
export const IconCustomerPortal: string = _IconCustomerPortal;
export const IconClose: string = _IconClose;
export const IconCloseBuilder: string = _IconCloseBuilder;
export const IconDocumentation: string = _IconDocumentation;
export const IconSignOut: string = _IconSignOut;
export const IconShowMore: string = _IconShowMore;
export const LogoLock: string = _LogoLock;
export const LogoDownload: string = _LogoDownload;

export const CKEditor5ArticleImageRightIcon: string = _ArticleImageRightIcon;
